import { getColorScheme } from '../../colors';
var segmentStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    var colors = getColorScheme(v.colorScheme, p.color);
    return Object.assign({
      borderColor: 'transparent',
      borderRadius: v.borderRadius,
      borderStyle: v.borderStyle,
      borderWidth: v.borderWidth,
      boxShadow: v.boxShadow,
      padding: v.padding,
      color: v.color,
      backgroundColor: v.backgroundColor
    }, p.color && {
      borderColor: colors.foreground
    }, {}, p.inverted && {
      color: v.backgroundColor,
      backgroundColor: p.color ? colors.foreground : v.color
    }, {}, p.disabled && Object.assign({
      boxShadow: 'none',
      borderColor: v.disabledBorderColor,
      color: v.disabledColor,
      backgroundColor: v.disabledBackgroundColor
    }, p.inverted && {
      color: v.disabledBackgroundColor,
      backgroundColor: v.disabledColor
    }));
  }
};
export default segmentStyles;